import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./PrimaryActionButton.scss";

/**
 * Primary action button component with optional left icon
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Button text
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {function} props.onClick - Click handler function
 * @param {boolean} props.loading - Whether to show loading spinner
 * @param {string} props.leftIconSrc - Optional URL for left icon image
 * @param {string} props.className - Optional additional CSS class
 * @param {string} props.type - Button type (button, submit, reset)
 * @param {Object} props.style - Optional inline styles
 */
const PrimaryActionButton = ({
  title,
  disabled = false,
  onClick,
  loading = false,
  leftIconSrc,
  className = "",
  type = "button",
  style = {},
  ...rest
}) => {
  return (
    <button
      className={`dexter-primary-action-button ${className} ${
        disabled ? "disabled" : ""
      } ${loading ? "loading" : ""}`}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      style={style}
      {...rest}
    >
      {!loading && leftIconSrc && (
        <img src={leftIconSrc} alt="" className="left-icon" />
      )}
      {loading ? (
        <CircularProgress size={16} style={{ color: "white" }} />
      ) : (
        <span className="button-text">{title}</span>
      )}
    </button>
  );
};

export default PrimaryActionButton;
